import {
  Datagrid,
  DateField,
  DeleteButton,
  EditButton,
  List,
  TextField,
  NumberField,
  Create,
  SimpleForm,
  ReferenceInput,
  AutocompleteInput,
  TextInput,
  SelectInput,
  NumberInput,
    Filter,
    SearchInput,
    DateInput,
    usePermissions,
    downloadCSV
} from "react-admin";
import jsonExport from 'jsonexport/dist';


// 👇 Filter component for the Offer list
const InputsFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <SelectInput
      source="type"
      label="Type"
      choices={[
        { id: "sell", name: "Sell" },
        { id: "buy", name: "Buy" },
      ]}
      allowEmpty
    />
    {/* <SelectInput
      source="status"
      label="Status"
      choices={[
        { id: "pending", name: "Pending" },
        { id: "approved", name: "Approved" },
        { id: "rejected", name: "Rejected" },
      ]}
      allowEmpty
    /> */}
    <ReferenceInput source="category_id" reference="inputs" label="Inputs" allowEmpty>
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
    <TextInput source="owner" label="Owner ID" />
    <DateInput source="created_at_gte" label="Created After" />
    <DateInput source="created_at_lte" label="Created Before" />
  </Filter>
);


const customExporter = (records) => {
  const csvData = records.map(record => ({
    UserName: record.user?.name || "",
    UserPhoneNumber: record.user?.phonenumber ? `'${record.user.phonenumber}` : "",
    InputCategoryName: record.input_category?.name || "",
    Description: record.description || "",
    Ingredients: record.ingredients || "",
    Application: record.application || "",
    Dose: record.dose || "",
    Cautions: record.cautions || "",
    Storing: record.storing || "",
    QualityCertificate: record.quality_certificate || "",
    Price: record.price || "",
  }));

  jsonExport(csvData, { rowDelimiter: ',' }, (err, csv) => {
    if (err) {
      console.error(err);
      return;
    }
    // Add UTF-8 BOM to fix Arabic characters in Excel
    const bom = '\uFEFF';
    downloadCSV(bom + csv, 'inputs_export');
  });
};

export const InputProductList = (props) => {
  return (
    <List {...props} filters={<InputsFilter/>}exporter={customExporter}>
      <Datagrid rowClick="edit">
        <TextField source="name" label="Product Name" />
        <TextField source="input_category.name" label="Category" />
        <NumberField source="price" label="Price" options={{ style: 'currency', currency: 'SDG' }} />
        <TextField source="user.phonenumber" label="User Phone" />
        <DateField source="created_at" label="Date" />
        <EditButton />
        <DeleteButton mutationMode="pessimistic" />
      </Datagrid>
    </List>
  );
};
export const InputProductCreate = (props) => {
  const { permissions } = usePermissions();
  const canEdit = permissions === "admin" || permissions === "operater";
  const transform = (data) => {
    console.log('Original form data:', data);
    
    const transformed = {
      owner: data.owner,
      category_id: Number(data.category_id),
      name: data.name,
      description: data.description,
      ingredients: data.ingredients || undefined,
      application: data.application || undefined,
      dose: data.dose || undefined,
      cautions: data.cautions || undefined,
      storing: data.storing || undefined,
      quality_certificate: data.quality_certificate || undefined,
      price: data.price ? Number(data.price) : undefined,
      images: data.images ? data.images.split(',').map(url => url.trim()) : [],
      state: data.state ? Number(data.state) : undefined,
      locality: data.locality ? Number(data.locality) : undefined,
      city: data.city ? Number(data.city) : undefined,
      market: data.market ? Number(data.market) : undefined,
      type: data.type || 'sell',
      status: data.status || 'active'
    };

    console.log('Transformed data:', transformed);
    return transformed;
  };

  return (
  canEdit?  <Create {...props} transform={transform} redirect="list">
      <SimpleForm className="max-w-6xl mx-auto">
        {/* Row 1: User and Category */}
        <div className="grid grid-cols-2 gap-6 mb-6">
          <ReferenceInput 
            source="owner" 
            reference="user" 
            validate={[required()]}
          >
            <AutocompleteInput 
              optionText="phonenumber"
              optionValue="id"
              label="User Phone"
              className="w-full"
            />
          </ReferenceInput>
          
          <ReferenceInput 
            source="category_id" 
            reference="inputs" 
            validate={[required()]}
          >
            <AutocompleteInput 
              optionText="name"
              optionValue="id"
              label="Input Category"
              className="w-full"
            />
          </ReferenceInput>
        </div>

        {/* Row 2: Product Name and Description */}
        <div className="grid grid-cols-2 gap-6 mb-6">
          <TextInput 
            source="name" 
            validate={[required()]}
            label="Product Name"
            className="w-full"
          />
          
          <TextInput 
            source="description" 
            validate={[required()]}
            label="Description"
            className="w-full"
          />
        </div>

        {/* Row 3: Product Details */}
        <div className="grid grid-cols-2 gap-6 mb-6">
          <TextInput 
            source="ingredients" 
            label="Ingredients (Optional)"
            className="w-full"
          />
          
          <TextInput 
            source="application" 
            label="Application Instructions (Optional)"
            className="w-full"
          />
        </div>

        {/* Row 4: More Product Details */}
        <div className="grid grid-cols-2 gap-6 mb-6">
          <TextInput 
            source="dose" 
            label="Dosage (Optional)"
            className="w-full"
          />
          
          <TextInput 
            source="cautions" 
            label="Cautions (Optional)"
            className="w-full"
          />
        </div>

        {/* Row 5: Storage and Certification */}
        <div className="grid grid-cols-2 gap-6 mb-6">
          <TextInput 
            source="storing" 
            label="Storage Instructions (Optional)"
            className="w-full"
          />
          
          <TextInput 
            source="quality_certificate" 
            label="Quality Certificate (Optional)"
            className="w-full"
          />
        </div>

        {/* Row 6: Pricing and Images */}
        <div className="grid grid-cols-2 gap-6 mb-6">
          <NumberInput 
            source="price" 
            min={0}
            label="Price (SDG)"
            className="w-full"
          />
          
          <TextInput 
            source="images" 
            label="Image URLs (comma separated)"
            className="w-full"
            helperText="Enter multiple image URLs separated by commas"
          />
        </div>

        {/* Row 7: Type and Status */}
        <div className="grid grid-cols-2 gap-6 mb-6">
          <SelectInput
            source="type"
            choices={[
              { id: "sell", name: "For Sale" },
              { id: "buy", name: "Wanted to Buy" },
            ]}
            defaultValue="sell"
            label="Listing Type"
            className="w-full"
          />
          
          <SelectInput
            source="status"
            choices={[
              { id: "active", name: "Active" },
              { id: "inactive", name: "Inactive" },
              { id: "pending", name: "Pending" },
            ]}
            defaultValue="active"
            label="Status"
            className="w-full"
          />
        </div>

        {/* Row 8: Location Information */}
        <div className="grid grid-cols-4 gap-6 mb-6">
          <ReferenceInput source="state" reference="state">
            <SelectInput 
              optionText="name" 
              optionValue="id"
              label="State (Optional)"
              className="w-full"
            />
          </ReferenceInput>
          
          <ReferenceInput source="locality" reference="locality">
            <SelectInput 
              optionText="name" 
              optionValue="id"
              label="Locality (Optional)"
              className="w-full"
            />
          </ReferenceInput>
          
          <ReferenceInput source="city" reference="city">
            <SelectInput 
              optionText="name" 
              optionValue="id"
              label="City (Optional)"
              className="w-full"
            />
          </ReferenceInput>
          
          <ReferenceInput source="market" reference="market">
            <SelectInput 
              optionText="name" 
              optionValue="id"
              label="Market (Optional)"
              className="w-full"
            />
          </ReferenceInput>
        </div>
      </SimpleForm>
    </Create> :undefined
  );
};

const required = (message = 'Required') => (value) => 
  value ? undefined : message;


export default InputProductList;
